// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fav-calculator-module{align-self:stretch}.fav-calculator-module__iframe{display:block;width:100%;min-height:600px;border:0}`, "",{"version":3,"sources":["webpack://./src/matchScreen/redesign/styles/FavCalculatorModule/FavCalculatorModule.scss"],"names":[],"mappings":"AAEA,uBAGE,kBAAA,CAMF,+BACE,aAAA,CACA,UAAA,CACA,gBAAA,CACA,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
